module.exports = __webpack_public_path__ + "4ed03a0639380c1c5fbd70f1e0a160d8.png";